import React, { JSX, useContext } from 'react'
import { FlexProps } from '@chakra-ui/react'

import { DateTimePickerContext } from 'components/form/DateTimePicker/helpers'
import { Loader } from 'components/ui/Loader'

import { LoaderWrapper } from './styles'

export const DateTimePickerLoader = ({ ...flexProps }: FlexProps): JSX.Element => {
  const { dateTimeState } = useContext(DateTimePickerContext)

  return (
    <LoaderWrapper alignItems="center" justifyContent="center" {...flexProps} isLoading={dateTimeState.isLoading}>
      <Loader marginY="unset" />
    </LoaderWrapper>
  )
}
